// A generated report takes five to ten minutes, and the tab is often left behind while it runs.
// Browsers stretch a background timer but never stop it, so a hidden tab keeps spending requests on
// a report nobody is looking at. Holding the next turn until the tab comes back turns that into no
// requests at all, and makes the first thing a returning reader gets a fresh answer rather than one
// that is up to a cadence old.
//
// The wait is only ever deferred, never skipped: a turn that comes due while hidden runs the moment
// the tab is shown again.
export const schedulePoll = (delayMs: number, run: () => void): (() => void) => {
  let timer: ReturnType<typeof setTimeout> | null = null
  let waiting = false

  const onVisible = (): void => {
    if ('hidden' === document.visibilityState) return
    document.removeEventListener('visibilitychange', onVisible)
    waiting = false
    run()
  }

  const fire = (): void => {
    timer = null
    if ('hidden' !== document.visibilityState) return run()
    waiting = true
    document.addEventListener('visibilitychange', onVisible)
  }

  timer = setTimeout(fire, delayMs)

  return (): void => {
    if (timer) clearTimeout(timer)
    timer = null
    if (waiting) document.removeEventListener('visibilitychange', onVisible)
    waiting = false
  }
}
